import React from 'react';
import { RECRUIT_STAGE_COLORS, RECRUIT_STAGE_HOLLOW, RECRUIT_STAGE_TICKED } from '../recruitStage';
import type { RecruitStage } from '../recruitStage';

/**
 * The one place a 招募階段 dot is drawn. Three surfaces show it — the drawer's
 * 階段 header pill, that pill's menu, and 快速資料's 階段 chips — and a dot
 * that means 未開始 on one of them and nothing in particular on another would
 * make the colour worth less than no colour at all.
 *
 * The shape markers (hollow ring for 未開始, tick for 已入職) are the reason
 * this is a component rather than a style object: they need an element and a
 * class, not just a `backgroundColor`. See ../recruitStage for why they exist.
 */
export type RecruitStageDotProps = {
  stage: RecruitStage;
  /** Extra class from the caller — e.g. the menu's own left margin. */
  className?: string;
};

const RecruitStageDot = ({ stage, className }: RecruitStageDotProps) => {
  const hollow = stage === RECRUIT_STAGE_HOLLOW;
  const ticked = stage === RECRUIT_STAGE_TICKED;
  const classes = ['clientv2-dot', 'clientv2-stagedot'];
  if (hollow) classes.push('is-hollow');
  if (ticked) classes.push('is-ticked');
  if (className) classes.push(className);

  // The colour rides on a custom property, so the hollow variant can paint it
  // as a ring (box-shadow) while every other stage paints it as a fill.
  return (
    <i
      className={classes.join(' ')}
      style={{ '--clientv2-stagedot': RECRUIT_STAGE_COLORS[stage] } as React.CSSProperties}
      data-stage={stage}
      aria-hidden="true"
    />
  );
};

export default RecruitStageDot;
